import LayoutPage from "../../Components/LayoutPage"
import EditRuleContainer from "./Components/EditRuleContainer"

export default function Rules() {
  return (
    <LayoutPage activeIndex={12} navItems={["مدیریت قوانین", "قانون ۹۷۳۰۱۷"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <EditRuleContainer />
    </LayoutPage>
  )
}